// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1c3e61b8","453":"b2ff150f","455":"07441e02","977":"8d9af773"}[chunkId] + ".chunk.js";
};